class HelperAnalyticsEvent {
    static defaultInfo = () => {
        return {
          pageInfo: window.adobeDataLayer?.[0]?._avnet?.pageInfo || {},
          userInfo: window.adobeDataLayer?.[0]?._avnet?.userInfo || {}
        }
      }

      static typeHeadSearchEvent(searchParam,tabType,linkName,url) {
        const searchEvent = {
          event: "typeheadSearch",
          _avnet: {
            internalSearchInfo: {
              searchType: "Internal",
              searchTerm: searchParam,
              searchTab: tabType,
            },
            linkInfo: {
              linkName: linkName,
              linkUrl: url,
              linkLocation: "typeheadSearchResults",
              linkType: "link",
              linkComponent: "typeheadPopup",
            },
            ...this.defaultInfo()
          },
        };
        window.adobeDataLayer.push(searchEvent);
      }
}

export default HelperAnalyticsEvent;